import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cd47368"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "info-icon__svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "info-icon__background",
    cx: "12",
    cy: "12",
    r: "11"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "info-icon__i",
    d: "M13.304 17.301c-.386.466-.87.699-1.449.699-.58 0-1.037-.149-1.372-.447-.322-.297-.483-.686-.483-1.165 0-.168.103-.873.31-2.116l.637-3.476h-.812l.039-.35h.83c.954 0 1.656-.038 2.107-.116l.27-.058-1.333 7.34c.387-.04.709-.22.966-.544l.29.233Zm-1.7-8.893a1.351 1.351 0 0 1-.406-.99c0-.389.135-.719.406-.99.27-.286.599-.428.985-.428.387 0 .715.142.986.427.283.272.425.602.425.99 0 .389-.142.719-.425.99-.27.273-.6.409-.986.409s-.715-.136-.985-.408Z"
  })
], -1))

import AppTooltip from '@/app/components/AppTooltip.vue'
import { ref } from 'vue'

/**
 * An icon that displays a tooltip on hover.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoIcon',
  setup(__props) {

const isHovering = ref(false)

function setIsHovering(newState: boolean): void {
  isHovering.value = newState
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "info-icon",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (setIsHovering(true))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (setIsHovering(false)))
  }, [
    _hoisted_1,
    _withDirectives(_createVNode(AppTooltip, {
      class: "info-icon__tooltip",
      position: "bottom",
      showArrow: true
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 512), [
      [_vShow, isHovering.value]
    ])
  ], 32))
}
}

})